module.exports = __webpack_public_path__ + "img/hr-V-L-3-unload-connect.6136d95d.png";